import { createFileRoute } from "@tanstack/react-router";
import { format } from "date-fns";
import type { JSX } from "react";

import { graphql } from "@repo/graphql-types";
import Left from "@repo/icons/default/Left";

import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import { CancelSubscriptionForm } from "@/components/subscription/forms/cancel-subscription-form";
import { CancellationStatus } from "@/components/subscription/cancellation/cancellation-status";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page, PageTitle } from "@/components/ui/layout/page/page";
import { CancellationStatusEnum } from "@/enums/cancellation-status";
import { useGraphQL } from "@/hooks/use-graphql";

const CancelSubscriptionQuery = graphql(`
  query CancelSubscriptionQuery($today: date!) {
    solicitacoesCancelamento(where: { solicitacaoAtendida: { _eq: false } }) {
      codStatusCancelamento
    }
    ...GiveUpCancellationFormFragment
    ...CancelSubscriptionFormPlanFragment
  }
`);

const FIVE_SECONDS = 5_000;

const CancelSubscriptionPage = (): JSX.Element => {
  const today = format(new Date(), "yyyy-MM-dd");
  const queryData = useGraphQL(
    CancelSubscriptionQuery,
    {
      today,
    },
    {
      refetchInterval: FIVE_SECONDS,
    },
  );

  const { data } = queryData;
  const userHasPendingCancellation =
    data?.solicitacoesCancelamento.length &&
    (data.solicitacoesCancelamento[0].codStatusCancelamento as CancellationStatusEnum) >=
      CancellationStatusEnum.InProgress &&
    (data.solicitacoesCancelamento[0].codStatusCancelamento as CancellationStatusEnum) !==
      CancellationStatusEnum.Canceled;

  const content = userHasPendingCancellation ? (
    <CancellationStatus data={data} />
  ) : (
    data && <CancelSubscriptionForm data={data} />
  );

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Assinatura" align="center" />
      </HeaderRoot>
      <Page>
        <PageTitle>Cancelar assinatura</PageTitle>
        <AsyncDataWrapper {...queryData}>{content}</AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute("/settings/profile/plan/cancel-subscription/")({
  component: CancelSubscriptionPage,
});
